// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e268861a","239":"7346ee38","455":"609a6dea"}[chunkId] + ".chunk.js";
};